export default __webpack_public_path__ + "static/media/CRAB-02.030b9a28.png";